var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "9.77 13.65 4.17 3.38 1.94 7.17 0.2 7.17 4.23 0.35 9.83 10.62 12.06 6.83 13.8 6.83 9.77 13.65"
})));
export default SvgTriangle;